import React from 'react';

const VideoTextPair = ({
  videoSrc,
  videoTitle,
  videoDescription,
  thumbnail,
  caption
}) => {
  return (
    <div className="video-text-section">
      <div className="small-video-container">
        <video
          controls
          className="small-video-frame"
          poster={thumbnail}
          controlsList="nodownload"
          onContextMenu={e => e.preventDefault()}>
          <source src={videoSrc} type="video/mp4" />
          <track
            kind="captions"
            src={caption}
            srcLang="en"
            label="English"
            default
          />
        </video>
      </div>
      <div className="video-description">
        <div className="description-title">{videoTitle}</div>
        <ul className="description-text">
          {videoDescription.map((description, index) => (
            <li key={index} className="description-text">
              {description}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default VideoTextPair;



// WEBPACK FOOTER //
// ./src/components/Videos/VideoTextPair.js